<div class="page">
  <header class="page-header">
    <div class="header-left">
      <h1 class="page-title">Leaderboard</h1>
      <p class="page-subtitle">Celebrate our top contributors and impactful ideas</p>
    </div>
    <button type="button" class="btn-points" (click)="openPointsModal()">
      <span class="btn-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="1.8"></circle>
          <path d="M9.7 9.3a2.6 2.6 0 0 1 4.92 1.2c0 1.63-1.68 2.12-2.36 2.72-.44.38-.55.65-.55 1.28" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"></path>
          <circle cx="12" cy="17.2" r="1" fill="currentColor"></circle>
        </svg>
      </span>
      How Points Work
    </button>
  </header>

  <div class="tabs">
    <button
      *ngFor="let t of tabs"
      type="button"
      class="tab"
      [class.active]="activeTab === t.key"
      (click)="setTab(t.key)"
    >
      {{ t.label }}
    </button>
  </div>

  <div *ngIf="errorMessage" class="error-banner" role="alert">{{ errorMessage }}</div>

  <div *ngIf="loading" class="loading-state">
    <app-loader label="Loading leaderboard"></app-loader>
  </div>

  <section *ngIf="!loading && !errorMessage && activeTab !== 'topIdeas'" class="list">
    <article *ngFor="let u of users" class="row">
      <div class="rank">
        <span class="rank-badge" [class.top1]="u.rank === 1" [class.top2]="u.rank === 2" [class.top3]="u.rank === 3">
          {{ rankIcon(u.rank) }}
        </span>
      </div>

      <div class="avatar" aria-hidden="true">{{ avatarEmoji(u.rank) }}</div>

      <div class="main">
        <div class="name-row">
          <span class="name">{{ u.displayName }}</span>
          <span *ngIf="u.badges?.length" class="pill">{{ primaryPillText(u) }}</span>
        </div>
        <div class="meta">{{ u.departmentName ?? '—' }}</div>
      </div>

      <div class="right">
        <div class="points" [ngClass]="userMetricClass()">{{ userPrimaryMetric(u) }}</div>
        <div class="secondary">{{ userSecondaryMetric(u) }}</div>
      </div>
    </article>

    <div *ngIf="users.length === 0" class="empty-state">
      <p>{{ usersEmptyStateMessage() }}</p>
    </div>
  </section>

  <section *ngIf="!loading && !errorMessage && activeTab === 'topIdeas'" class="list">
    <article *ngFor="let i of ideas; let idx = index" class="row idea-row">
      <div class="rank">
        <span class="rank-badge" [class.top1]="idx + 1 === 1" [class.top2]="idx + 1 === 2" [class.top3]="idx + 1 === 3">
          {{ rankIcon(idx + 1) }}
        </span>
      </div>

      <div class="main">
        <a class="idea-title" [routerLink]="['/ideas', i.ideaId]">{{ i.title }}</a>
        <p class="idea-description">{{ ideaDescription(i) }}</p>
        <div class="meta">
          <span>by {{ i.ownerDisplayName ?? 'Unknown' }}</span>
          <span class="dot">•</span>
          <span class="category-chip">{{ ideaMetaCategory(i) }}</span>
        </div>
      </div>

      <div class="right right-idea-metrics">
        <div class="idea-stat">
          <span class="idea-stat-value">{{ i.likes | number }}</span>
          <span class="idea-stat-icon">👍</span>
        </div>
        <div class="secondary secondary-idea">
          <span class="idea-stat-value">{{ i.comments | number }}</span>
          <span class="idea-stat-muted">💬</span>
        </div>
      </div>
    </article>

    <div *ngIf="ideas.length === 0" class="empty-state">
      <p>No ideas to show yet.</p>
    </div>
  </section>
</div>

<div
  *ngIf="showPointsModal"
  class="modal-overlay"
  role="dialog"
  aria-modal="true"
  aria-labelledby="points-modal-title"
  (click)="closePointsModal()"
>
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 id="points-modal-title">How Points Work</h2>
      <button type="button" class="modal-close" (click)="closePointsModal()" aria-label="Close">&times;</button>
    </div>

    <div class="modal-body">
      <h3 class="section-title">Earning Points</h3>
      <ul class="rules rules-simple">
        <li>Submit an idea: 25 points</li>
        <li>Idea moves to Triage: +25 points</li>
        <li>Idea Accepted: +75 points</li>
        <li>Idea Delivered: +150 points</li>
        <li>Challenge winner: +500-1000 points</li>
        <li>Each like on your idea: +2 points</li>
      </ul>

      <h3 class="section-title">Badges</h3>
      <ul class="rules rules-simple">
        <li>Innovator: Submit 10+ ideas</li>
        <li>Problem Solver: 5+ delivered ideas</li>
        <li>Collaborator: High engagement score</li>
        <li>Top Contributor: 1000+ points</li>
      </ul>
    </div>
  </div>
</div>
